import * as yup from "yup";
import type { Asserts } from "yup";

// Response from here lookup endpoint validation

const addressSchema = yup.object({
  city: yup.string().optional(),
  street: yup.string().optional(),
  houseNumber: yup.string().optional(),
  postalCode: yup.string().optional(),
});

const addressDetailsSchema = yup.object({
  id: yup.string().required(),
  title: yup.string().required(),
  address: addressSchema.required(),
});

export type TAddressDetailsResponse = Asserts<typeof addressDetailsSchema>;

const validateAddressDetailsResponse = (response: any): TAddressDetailsResponse =>
  addressDetailsSchema.validateSync(response);

export default validateAddressDetailsResponse;
